const externalURLs = {
    TERMS_AND_CONDITIONS : 'https://influns.com/legal/terms.html'
}

export default externalURLs;